import { NotificationSettingFormModel } from './NotificationSettingForm';
import { StatusType } from './Constants';
var NotificationSettingTypeFormModel = /** @class */ (function () {
    function NotificationSettingTypeFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.audit, audit = _b === void 0 ? new NotificationSettingFormModel() : _b, _c = _a.reject, reject = _c === void 0 ? new NotificationSettingFormModel() : _c;
        this.audit = audit;
        this.reject = reject;
    }
    NotificationSettingTypeFormModel.prototype.createNotificationSetting = function (data) {
        var notificationSettingForm = new NotificationSettingFormModel({
            id: data.id,
            accountId: data.accountId,
            isNotify: data.isNotify,
            frequency: data.frequency,
        });
        if (data.notificationType.includes(StatusType.audit))
            this.audit = notificationSettingForm;
        if (data.notificationType.includes(StatusType.reject))
            this.reject = notificationSettingForm;
    };
    NotificationSettingTypeFormModel.prototype.passToCorrespondingStatusType = function (items, method, type, accountId) {
        this.audit.addChangedNotification(items, method, type, StatusType.audit, accountId);
        this.reject.addChangedNotification(items, method, type, StatusType.reject, accountId);
    };
    return NotificationSettingTypeFormModel;
}());
export { NotificationSettingTypeFormModel };
